import React, { useState, useEffect } from 'react';

export function initZoom() {
    const storedZoom = localStorage.getItem('zoomLevel');
    if (storedZoom) {
        document.body.style.zoom = parseFloat(storedZoom);
    }
}


export function useHiddenSettingsClickHandler() {
    // This state tracks how many times we’ve clicked on the “secret trigger”.
    const [clickCount, setClickCount] = useState(0);

    // This state determines whether the settings dialog is showing.
    const [isOpen, setIsOpen] = useState(false);

    // Provide a click handler to attach to any element in App.js.
    function handleElementClick() {
        setClickCount((prevCount) => {
            const newCount = prevCount + 1;
            if (newCount >= 10) {
                setIsOpen(true);
                return 0; // reset click count after opening
            }
            return newCount;
        });
    }

    // Provide a way for the user to close the dialog.
    function handleClose() {
        setIsOpen(false);
    }

    // Return both the handler and a component that 
    // can actually render the HiddenSettings UI if isOpen is true.
    const HiddenSettingsUI = () => {
        if (!isOpen) return null;
        return <HiddenSettings onClose={handleClose} />;
    };

    return { handleElementClick, HiddenSettingsUI };
}

/**
 * The HiddenSettings dialog itself. 
 * It's “dumb” — it only knows how to render a close button and handle zoom changes.
 */
function HiddenSettings({ onClose }) {
    // Initialize zoom from localStorage or default to 1
    const [zoomLevel, setZoomLevel] = useState(() => {
        const storedZoom = localStorage.getItem('zoomLevel');
        return storedZoom ? parseFloat(storedZoom) : 1;
    });

    // Update the document and localStorage whenever zoom changes
    useEffect(() => {
        document.body.style.zoom = zoomLevel;
        localStorage.setItem('zoomLevel', zoomLevel);
    }, [zoomLevel]);

    const handleZoomChange = (e) => {
        const newZoom = parseFloat(e.target.value) || 1;
        setZoomLevel(newZoom);
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.dialog}>
                <h2>Settings</h2>

                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ marginRight: '0.5rem' }}>Zoom Level:</label>
                    <input
                        type="number"
                        step="0.1"
                        min="0.5"
                        max="3"
                        value={zoomLevel}
                        onChange={handleZoomChange}
                        style={{ width: '4rem' }}
                    />
                    <span style={{ marginLeft: '0.5rem' }}>
                        {Math.round(zoomLevel * 100)}%
                    </span>
                </div>

                {/* Future hidden options can go here */}

                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
}

// Some basic inline styles for the overlay and dialog
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
    },
    dialog: {
        background: '#fff',
        padding: '1.5rem',
        borderRadius: '4px',
        minWidth: '300px',
    },
};

export default HiddenSettings;
